import React, {Fragment} from 'react';
import Icon from '../../../../core/scripts/components/Icon';


export function MapList(props) {
  if(props.mapdata !=null) {
    const limit = (props.showAll) ? props.mapdata.length : 10;
    const maps = props.mapdata.map((entry, index) => {
      if(index < limit) {
        return (
          <Fragment key={index}>
            <div className="winter-item">
              <MapImage imageId={entry.winter_id}/>
              <Headline years={entry.winter_id}/>
              <Stats data={entry} />
            </div>
           </Fragment>
        )
      }
    });
    return (
      <div className="winter-list">
        {maps}
      </div>
    );
  }
  else {
    return (
      <div className="winter-list">
        <p className="loading">Loading...</p>
      </div>
    );
  }
}
function MapImage(props) {
  const images = require.context('../../../../assets/images/maps', true);
  try {
    var imgsrc = images(`./${props.imageId}.jpg`);
  } catch (err){
   console.log("image not found");
  }
  if(imgsrc != null) {
    return (
      <img className="winter-item__map" src={imgsrc} alt="Anzahl Schneetage"/>
    );
  }
  else {
    return (
      <p className="loading">loading</p>
    );
  }

}
function Stats(props) {
  const winterItemRowClassWaermste = (props.data.record == 2) ? "winter-item__row record" : "winter-item__row";
  const winterItemRowClassKaelteste = (props.data.record == 3) ? "winter-item__row record" : "winter-item__row";
  const winterItemRowClassMaxSnow = (props.data.record == 1) ? "winter-item__row record" : "winter-item__row";
  return (
    <Fragment>
      <div className="winter-item__temperature">
        <Icon type="temperature"/>
        <div className="winter-item__row">
          <span className="winter-item__row-label">Mittlere</span>
          <span className="winter-item__row-value">{props.data.mean_temp}&nbsp;°C</span>
        </div>
        <div className={winterItemRowClassWaermste}>
          <span className="winter-item__row-label">Wärmste</span>
          <span className="winter-item__row-value">{props.data.maxtemp}&nbsp;°C</span>
        </div>
        {props.data.record == 2 && <div className="winter-item__row record record-value">Rekord: {props.data.name_maxtemp}</div>}
        <div className={winterItemRowClassKaelteste}>
          <span className="winter-item__row-label">Kälteste</span>
          <span className="winter-item__row-value">{props.data.mintemp}&nbsp;°C</span>
        </div>
        {props.data.record == 3 && <div className="winter-item__row record record-value">Rekord: {props.data.name_mintemp}</div>}
      </div>
      <div className="winter-item__snow ">
        <Icon type="snow"/>
        <div className={winterItemRowClassMaxSnow}>
          <span className="winter-item__row-label">max. Schneehöhe</span>
          <span className="winter-item__row-value">{props.data.maxsnow}&nbsp;cm</span>
        </div>
        {props.data.record == 1 && <div className="winter-item__row record record-value">Rekord: {props.data.name_maxsnow}</div>}
      </div>
    </Fragment>
  );
}
function Headline(props) {
  const years = props.years.split("_");
  return (
    <Fragment>
        <div className="winter-item__title">
        Winter {years[0]} / {years[1]}
        </div>
    </Fragment>
  );
}
